import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import DeleteModal from "../common/DeleteModal";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../../pages/ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../common/UseCountryNavigate";

const Stream = () => {
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const menuRefs = useRef([]);
  const [refresh, setRefresh] = useState(false);
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  console.log("permissions", permissions);
  const location = useLocation();
  const isAccessible =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("view_Education") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Education") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Education") || permissions?.includes("delete_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");
  const mode = localStorage.getItem("mode");
  const { id } = useParams();
  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
    // setOpenMenuIndex(true);
  };

  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.stream_delete, { id: id, school_id: schoolId }).then(
      (res) => {
        if (res.status === 200) {
          toast.success(res.message);
          setRefresh(!refresh);
        }
        // else {
        //     dispatch(message(res.message));
        // }
      }
    );
    setLoader(false);
    setOpenMenuIndex(null);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.stream_list, { school_id: schoolId }).then((res) => {
      if (res.status === 200) {
        setData(res.data);
      }
      //  else {

      //     dispatch(message(res.message));
      // }
    });
    setLoader(false);
  };
  useEffect(() => {
    fetchData();
  }, [refresh]);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      let clickedInside = false;
      menuRefs.current.forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          clickedInside = true;
        }
      });
      if (!clickedInside) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    // Navigate to /settings with currentTab only once
    if (location?.state?.currentTab !== "Streams") {
      if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
        if (mode === "view") {
          navigate(`admin-school/view/${schoolId}`, {
            state: { mainTab: "Education", currentTab: "Streams" },
          });
        } else {
          navigate("navigation-dashboard", {
            replace: true,
            state: { mainTab: "Education", currentTab: "Streams" },
          });
        }
      } else {
        navigate(`education`, {
          replace: true,
          state: { currentTab: "Streams" },
        });
      }
    }
  }, []);

  if (loader) {
    return <div>Loading....</div>;
  }
  if (!isAccessible) {
    return <Error403Page />;
  }
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        {data.length > 0 &&
          data.map((item, index) => (
            <div className="bg-white rounded-lg p-6  relative text-gray-800  ">
              <div>
                <h2 className="text-2xl font-semibold mb-2 whitespace-normal break-words">
                  {item.grade}
                </h2>
                <div className="grid grid-cols-1 md:flex md:justify-between   ">
                  <div className="text-sm mb-4 text-gray-600 whitespace-normal break-words  max-w-[50%]">
                    Stream : {item.name}
                  </div>
                  <div className="text-sm mb-4 text-gray-600">
                    No.Of Students : {item.no_of_students}
                  </div>
                </div>
                <div className="flex items-center gap-2 mb-4 w-full  whitespace-normal break-words">
                  <div>
                    <img
                      className="w-10 h-10 object-cover rounded-full"
                      src={item.teacher_image}
                      alt="Teacher"
                    />
                  </div>

                  <div className="text-sm whitespace-normal break-words flex-1">
                    {item.teacher}
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-sm leading-relaxed whitespace-normal break-words">
                    {item.description
                      ? item.description
                      : "No Details available for this Teacher."}
                  </p>
                </div>
              </div>
              {(addPermission || deletePermission) && (
                <div className="bg-white ">
                  <div className="absolute top-3 right-3">
                    <button onClick={() => toggleMenu(index)}>
                      <img
                        src={HiOutlineDotsVertical}
                        className="text-black-500 hover:text-black"
                      />
                    </button>

                    {openMenuIndex == index && (
                      <div
                        ref={(el) => (menuRefs.current[index] = el)}
                        className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10"
                      >
                        {addPermission && (
                          <button
                            className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                            onClick={() =>
                              navigate(`education/streams/edit/${item._id}`, {
                                state: { type: "edit" },
                              })
                            }
                          >
                            Edit
                          </button>
                        )}
                        {deletePermission && (
                          <button
                            onClick={() => {
                              setSelectedId(item._id);
                              setmodalOpenDelete(true);
                            }}
                            className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}
        <DeleteModal
          title="Delete Stream"
          message="Are you sure you want to delete Stream?
It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setmodalOpenDelete}
          handleDelete={handleDelete} // Don't call it here
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          module={"Stream"}
          redirectPage={"Education"}
          redirectUrl={
            mode === "view"
              ? `admin-school/view/${schoolId}`
              : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                ? "navigation-dashboard"
                : "education"
          }
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
        />
      </div>
      {data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Stream;
